module.exports = __webpack_public_path__ + "img/zmb.a9ff495d.svg";